require("./a-camera.html");
require("./a-cube.html");
require("./a-curvedimage.html");
require("./a-cylinder.html");
require("./a-frame.html");
require("./a-image.html");
require("./a-light.html");
require("./a-model.html");
require("./a-plane.html");
require("./a-sky/index.html");
require("./a-sphere.html");
require("./a-video.html");
require("./a-videosphere.html");
document.addEventListener("DOMContentLoaded",function() {
var head = document.getElementsByTagName("head")[0];
head.insertAdjacentHTML("beforeend","<meta charset=\"utf-8\">");

})